"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Metaform REST API
 * REST API for Metaform
 *
 * The version of the OpenAPI document: 2.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
const runtime_1 = require("../runtime");
function ExportThemeFileFromJSON(json) {
    return ExportThemeFileFromJSONTyped(json, false);
}
exports.ExportThemeFileFromJSON = ExportThemeFileFromJSON;
function ExportThemeFileFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': !runtime_1.exists(json, 'id') ? undefined : json['id'],
        'path': json['path'],
        'themeId': json['themeId'],
        'content': json['content'],
    };
}
exports.ExportThemeFileFromJSONTyped = ExportThemeFileFromJSONTyped;
function ExportThemeFileToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'path': value.path,
        'themeId': value.themeId,
        'content': value.content,
    };
}
exports.ExportThemeFileToJSON = ExportThemeFileToJSON;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiRXhwb3J0VGhlbWVGaWxlLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vc3JjL2dlbmVyYXRlZC9jbGllbnQvbW9kZWxzL0V4cG9ydFRoZW1lRmlsZS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiO0FBQUEsb0JBQW9CO0FBQ3BCLG9CQUFvQjtBQUNwQjs7Ozs7Ozs7OztHQVVHOztBQUVILHdDQUErQztBQWlDL0MsU0FBZ0IsdUJBQXVCLENBQUMsSUFBUztJQUM3QyxPQUFPLDRCQUE0QixDQUFDLElBQUksRUFBRSxLQUFLLENBQUMsQ0FBQztBQUNyRCxDQUFDO0FBRkQsMERBRUM7QUFFRCxTQUFnQiw0QkFBNEIsQ0FBQyxJQUFTLEVBQUUsbUJBQTRCO0lBQ2hGLElBQUksQ0FBQyxJQUFJLEtBQUssU0FBUyxDQUFDLElBQUksQ0FBQyxJQUFJLEtBQUssSUFBSSxDQUFDLEVBQUU7UUFDekMsT0FBTyxJQUFJLENBQUM7S0FDZjtJQUNELE9BQU87UUFFSCxJQUFJLEVBQUUsQ0FBQyxnQkFBTSxDQUFDLElBQUksRUFBRSxJQUFJLENBQUMsQ0FBQyxDQUFDLENBQUMsU0FBUyxDQUFDLENBQUMsQ0FBQyxJQUFJLENBQUMsSUFBSSxDQUFDO1FBQ2xELE1BQU0sRUFBRSxJQUFJLENBQUMsTUFBTSxDQUFDO1FBQ3BCLFNBQVMsRUFBRSxJQUFJLENBQUMsU0FBUyxDQUFDO1FBQzFCLFNBQVMsRUFBRSxJQUFJLENBQUMsU0FBUyxDQUFDO0tBQzdCLENBQUM7QUFDTixDQUFDO0FBWEQsb0VBV0M7QUFFRCxTQUFnQixxQkFBcUIsQ0FBQyxLQUE4QjtJQUNoRSxJQUFJLEtBQUssS0FBSyxTQUFTLEVBQUU7UUFDckIsT0FBTyxTQUFTLENBQUM7S0FDcEI7SUFDRCxJQUFJLEtBQUssS0FBSyxJQUFJLEVBQUU7UUFDaEIsT0FBTyxJQUFJLENBQUM7S0FDZjtJQUNELE9BQU87UUFFSCxJQUFJLEVBQUUsS0FBSyxDQUFDLEVBQUU7UUFDZCxNQUFNLEVBQUUsS0FBSyxDQUFDLElBQUk7UUFDbEIsU0FBUyxFQUFFLEtBQUssQ0FBQyxPQUFPO1FBQ3hCLFNBQVMsRUFBRSxLQUFLLENBQUMsT0FBTztLQUMzQixDQUFDO0FBQ04sQ0FBQztBQWRELHNEQWNDIn0=